import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'antd/dist/reset.css';

(function bootstrap() {
  var el = document.getElementById('root');
  if (!el) return;

  try {
    var root = ReactDOM.createRoot(el);
    root.render(React.createElement(App));
  } catch (e) {
    el.innerHTML = '<div style="padding:60px 20px;text-align:center;font-family:sans-serif">' +
      '<h2 style="color:#ff4d4f">应用初始化失败</h2>' +
      '<p style="color:#666;font-size:13px">' + (e.message || '未知错误') + '</p>' +
      '<p style="color:#999;font-size:12px;margin-top:24px">请尝试重启软件或联系技术支持</p>' +
      '</div>';
    console.error('App bootstrap error:', e);
  }
})();
